var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy-02",
    clipPath: "url(#clip0_0_56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.6667 5.33333V3.46667C10.6667 2.71993 10.6667 2.34656 10.5213 2.06135C10.3935 1.81046 10.1895 1.60649 9.93865 1.47866C9.65344 1.33333 9.28007 1.33333 8.53333 1.33333H3.46667C2.71993 1.33333 2.34656 1.33333 2.06135 1.47866C1.81046 1.60649 1.60649 1.81046 1.47866 2.06135C1.33333 2.34656 1.33333 2.71993 1.33333 3.46667V8.53333C1.33333 9.28007 1.33333 9.65344 1.47866 9.93865C1.60649 10.1895 1.81046 10.3935 2.06135 10.5213C2.34656 10.6667 2.71993 10.6667 3.46667 10.6667H5.33333M7.46667 14.6667H12.5333C13.2801 14.6667 13.6534 14.6667 13.9387 14.5213C14.1895 14.3935 14.3935 14.1895 14.5213 13.9387C14.6667 13.6534 14.6667 13.2801 14.6667 12.5333V7.46667C14.6667 6.71993 14.6667 6.34656 14.5213 6.06135C14.3935 5.81046 14.1895 5.60649 13.9387 5.47866C13.6534 5.33333 13.2801 5.33333 12.5333 5.33333H7.46667C6.71993 5.33333 6.34656 5.33333 6.06135 5.47866C5.81046 5.60649 5.60649 5.81046 5.47866 6.06135C5.33333 6.34656 5.33333 6.71993 5.33333 7.46667V12.5333C5.33333 13.2801 5.33333 13.6534 5.47866 13.9387C5.60649 14.1895 5.81046 14.3935 6.06135 14.5213C6.34656 14.6667 6.71993 14.6667 7.46667 14.6667Z",
    stroke: "#0D70DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bace7290f36f9845df5f0b0548879df6.svg";
export { ForwardRef as ReactComponent };